import { render, staticRenderFns } from "./upd-email-modal.vue?vue&type=template&id=309bfd98&"
import script from "./upd-email-modal.vue?vue&type=script&lang=js&"
export * from "./upd-email-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports